<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Norm-Cen__And__Page_Break"><span><img alt="" src="image1.jpg" style=" max-width: 100%; max-height: 100%;"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?644b0299